module.exports = __webpack_public_path__ + "static/tools-c32376454619b6a6c231c4454bc47699.png";